export default __webpack_public_path__ + "static/media/ryan.23196434.jpg";